import React, { useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTheme } from "../../_core/ThemeProvider";
import { MoonIcon, SunIcon } from "../../../../app/components/jds/icons";

export function ThemeToggle() {
  const { theme, toggle, lightOnly } = useTheme();
  const wrapRef = useRef(null);
  // modo efetivo: páginas light-only forçam o claro mesmo com dark salvo
  const dark = theme === "dark" && !lightOnly;
  const mode = dark ? "Modo escuro" : "Modo claro";
  const action = lightOnly
    ? "Modo escuro indisponível nesta página"
    : `Mudar para ${dark ? "modo claro" : "modo escuro"}`;

  return (
    // container: o tooltip NÃO pode ir para document.body. No React 17, o
    // primeiro portal em body registra os listeners do React lá, e aí o
    // flushPassiveEffects roda no meio do mesmo click que abriu um
    // react-bootstrap Dropdown (react-overlays 3.2): o rootClose registrado
    // nesse instante fecha o menu na hora (pill "Olá, <nome>" nunca abre).
    <OverlayTrigger
      placement="bottom"
      container={wrapRef}
      overlay={<Tooltip id="theme-toggle-tooltip">{action}</Tooltip>}
    >
      <div className="topbar-item" ref={wrapRef}>
        <button
          type="button"
          className={`btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 mr-1${
            lightOnly ? " disabled" : ""
          }`}
          aria-label={action}
          aria-disabled={lightOnly || undefined}
          onClick={lightOnly ? undefined : toggle}
        >
          <span className="svg-icon">{dark ? <MoonIcon /> : <SunIcon />}</span>
          <span className="text-muted font-weight-bold font-size-base d-none d-md-inline ml-2">
            {mode}
          </span>
        </button>
      </div>
    </OverlayTrigger>
  );
}
